import pkginfo from './pkginfo.json';
export var VERSION = pkginfo.version;
